import React from 'react'
import clsx from 'clsx'

import { toTitleCase } from '../../../utilities'
import useStyles from './styles'

type TabProps = React.HTMLAttributes<HTMLDivElement> & {
  title: string
  selected: boolean
  count: number
}

const Tab: React.FC<TabProps> = ({
  title,
  selected,
  count,
  className,
  ...props
}) => {
  const classes = useStyles()

  return (
    <div
      className={clsx(classes.root, selected && classes.selected, className)}
      {...props}
    >
      {toTitleCase(title)}
      {!selected && count > 0 && <div className={classes.count}>{count}</div>}
    </div>
  )
}

export default Tab
